<template>
    <b-modal id="edit_modal" title="Στοιχεία Διαχειριστή" size="l" @ok="edit">
      <b-form @submit.stop.prevent>
        <b-form-group label="Επώνυμο:">
          <b-form-input :value="selectedAdmin.epwnymo"
                        trim disabled></b-form-input>
        </b-form-group>
        <b-form-group label="Όνομα:">
          <b-form-input :value="selectedAdmin.onoma"
                        trim disabled></b-form-input>
        </b-form-group>
        <b-form-group label="Α.Μ.:">
          <b-form-input :value="selectedAdmin.strkProsKwd"
                        trim disabled></b-form-input>
        </b-form-group>
        <b-form-group v-if="isManager" label="Είδος Διαχειριστή (Παρακολ. Μονάδα) : " label-align="left">
          <b-form-select :value="selectedAdmin.monaLek"
                         :options="me_items"></b-form-select>
        </b-form-group>
        <b-form-group label="E-mail:" label-align="left">
          <b-form-input :value="editedAdminEmail"
                 @change="onChangeEmail"
                 trim></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
</template>

<script>
import {Structs} from "@/structs";
import {HTTP} from "@/main";
import Toast from "@/components/super_admin/toast/Toast";

export default {
  name: "EditAdminModal",
  components: {Toast},
  props: {
    selectedAdmin: {
      type: Object
    },
    me_items: {
      type: Array
    },
    initModal: {
      type: Boolean
    }
  },
  data() {
    return {
      toastOptions: {
        title: "Επεξεργασία Διαχειριστή",
        text: "",
        variant: ""
      },
      editedAdminEmail: ''
    }
  },
  methods: {
    edit: function () {
      let item = Structs.Admin()
      item.strkProsKwd = this.selectedAdmin.strkProsKwd;
      item.email = this.editedAdminEmail;
      item.parakolMonada = this.selectedAdmin.adiavMeeMona;

      this.show_error = false;

      if (!this.$validator.validateEmail(item.email)) {
        this.showToast("Παρακαλώ εισάγετε ένα έγκυρο E-mail.", "danger");
        return
      }

      let url;
      if (this.isManager) {
        if (item.parakolMonada.efEaPinakaE === '') {
          this.showToast( "Παρακαλώ εισάγετε μία έγκυρη μονάδα.", "danger");
          return
        }
        url = "/manager/edit"
      } else if(this.isDeps) {
        url = "/manager/edit";
        item.deps = this.selectedAdmin.deps;
        item.depsKwd = this.selectedAdmin.depsKwd;
      } else
        url = "/admin/edit"

      this.$store.dispatch("loading")
      HTTP.post(url, item)
        .then((response) => {
          this.showToast("Η επεξεργασία ήταν επιτυχής", "success");
          this.returnNewEmail()
        }).catch((e) => {
        if (e.response.data.errorMessage) {
          this.showToast(e.response.data.errorMessage)
        } else {
          this.showToast('Υπήρξε κάποιο πρόβλημα κατά την επεξεργασία του Διαχειριστή.', "danger")
        }
      }).finally(() => this.$store.dispatch("stop_loading"));
    },
    showToast: function (msg, variant) {
      this.toastOptions.text = msg
      this.toastOptions.variant = variant
      this.$emit('showToast', this.toastOptions)
    },
    onChangeEmail: function (email) {
      this.editedAdminEmail = email
    },
    returnNewEmail: function () {
      this.$emit('returnNewEmail', this.editedAdminEmail)
    }
  },
  computed: {
    isManager: function () {
      return this.selectedAdmin.idRolos === "22" ? true : false
    },
    isDeps: function () {
      return this.selectedAdmin.idRolos === "23" ? true : false
    },
  },
  beforeUpdate() {
    if(this.initModal) {
      this.editedAdminEmail = this.selectedAdmin.email
    }
    this.initModal = false
  }

}
</script>

<style scoped>

</style>
